import { render } from "./Sequence-View.vue?vue&type=template&id=22063bde&scoped=true"
import script from "./Sequence-View.vue?vue&type=script&lang=js"
export * from "./Sequence-View.vue?vue&type=script&lang=js"

import "./Sequence-View.vue?vue&type=style&index=0&id=22063bde&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-22063bde"

export default script